/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  PercentageERC20FeeHandler,
  PercentageERC20FeeHandlerInterface,
} from "../PercentageERC20FeeHandler";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "bridgeAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "feeHandlerRouterAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "IncorrectFeeSupplied",
    type: "error",
  },
  {
    inputs: [],
    name: "ZeroAddress",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "newLowerBound",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newUpperBound",
        type: "uint256",
      },
    ],
    name: "FeeBoundsChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "newFee",
        type: "uint256",
      },
    ],
    name: "FeeChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "fromDomainID",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "destinationDomainID",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "fee",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
    ],
    name: "FeeCollected",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "FeeDistributed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "HUNDRED_PERCENT",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "_bridgeAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "_domainResourceIDToFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "_feeHandlerRouterAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "_resourceIDToFeeBounds",
    outputs: [
      {
        internalType: "uint128",
        name: "lowerBound",
        type: "uint128",
      },
      {
        internalType: "uint128",
        name: "upperBound",
        type: "uint128",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "destinationDomainID",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "newFee",
        type: "uint256",
      },
    ],
    name: "changeFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "getRoleMemberIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newAdmin",
        type: "address",
      },
    ],
    name: "renounceAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address payable[]",
        name: "addrs",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
    ],
    name: "transferFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "feeHandlerType",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "pure",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "uint8",
        name: "fromDomainID",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "destinationDomainID",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
      {
        internalType: "bytes",
        name: "depositData",
        type: "bytes",
      },
      {
        internalType: "bytes",
        name: "feeData",
        type: "bytes",
      },
    ],
    name: "calculateFee",
    outputs: [
      {
        internalType: "uint256",
        name: "fee",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "uint8",
        name: "fromDomainID",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "destinationDomainID",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
      {
        internalType: "bytes",
        name: "depositData",
        type: "bytes",
      },
      {
        internalType: "bytes",
        name: "feeData",
        type: "bytes",
      },
    ],
    name: "collectFee",
    outputs: [],
    stateMutability: "payable",
    type: "function",
    payable: true,
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
      {
        internalType: "uint128",
        name: "newLowerBound",
        type: "uint128",
      },
      {
        internalType: "uint128",
        name: "newUpperBound",
        type: "uint128",
      },
    ],
    name: "changeFeeBounds",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
      {
        internalType: "address[]",
        name: "addrs",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
    ],
    name: "transferERC20Fee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type PercentageERC20FeeHandlerConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: PercentageERC20FeeHandlerConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class PercentageERC20FeeHandler__factory extends ContractFactory {
  constructor(...args: PercentageERC20FeeHandlerConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "PercentageERC20FeeHandler";
  }

  deploy(
    bridgeAddress: string,
    feeHandlerRouterAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<PercentageERC20FeeHandler> {
    return super.deploy(
      bridgeAddress,
      feeHandlerRouterAddress,
      overrides || {}
    ) as Promise<PercentageERC20FeeHandler>;
  }
  getDeployTransaction(
    bridgeAddress: string,
    feeHandlerRouterAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      bridgeAddress,
      feeHandlerRouterAddress,
      overrides || {}
    );
  }
  attach(address: string): PercentageERC20FeeHandler {
    return super.attach(address) as PercentageERC20FeeHandler;
  }
  connect(signer: Signer): PercentageERC20FeeHandler__factory {
    return super.connect(signer) as PercentageERC20FeeHandler__factory;
  }
  static readonly contractName: "PercentageERC20FeeHandler";
  public readonly contractName: "PercentageERC20FeeHandler";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): PercentageERC20FeeHandlerInterface {
    return new utils.Interface(_abi) as PercentageERC20FeeHandlerInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): PercentageERC20FeeHandler {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as PercentageERC20FeeHandler;
  }
}
